export function requireRole ( allowedUserTypes ) {
  return ( to, from, next ) => {
    let userType = localStorage.getItem( "userType" );
    if ( allowedUserTypes.map( String ).includes( String( userType ) ) ) {
      next();
    } else {
      next( "/dashboard" );
    }
  };
}
